module.exports = __webpack_public_path__ + "static/media/unionpay.9b59a572.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/unionpay.svg
// module id = 1485
// module chunks = 0